/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Upload_Error_ParseInputs */

const en_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not parse your resume`)
};

const de_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf konnte nicht gelesen werden`)
};

const fr_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'analyser votre CV`)
};

const es_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo analizar tu curriculo`)
};

const it_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile analizzare il tuo CV`)
};

const nl_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan uw cv niet analyseren`)
};

const pl_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udalo sie przeanalizowac Twojego CV`)
};

const fi_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluetteloa ei voitu jäsentää`)
};

const da_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke analysere dit CV`)
};

const sv_onboarding_upload_error_parse = /** @type {(inputs: Onboarding_Upload_Error_ParseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte analysera ditt CV`)
};

/**
* | output |
* | --- |
* | "Could not parse your resume" |
*
* @param {Onboarding_Upload_Error_ParseInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_upload_error_parse = /** @type {((inputs?: Onboarding_Upload_Error_ParseInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Upload_Error_ParseInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_upload_error_parse(inputs)
	if (locale === "fr") return fr_onboarding_upload_error_parse(inputs)
	if (locale === "es") return es_onboarding_upload_error_parse(inputs)
	if (locale === "it") return it_onboarding_upload_error_parse(inputs)
	if (locale === "nl") return nl_onboarding_upload_error_parse(inputs)
	if (locale === "pl") return pl_onboarding_upload_error_parse(inputs)
	if (locale === "fi") return fi_onboarding_upload_error_parse(inputs)
	if (locale === "da") return da_onboarding_upload_error_parse(inputs)
	if (locale === "sv") return sv_onboarding_upload_error_parse(inputs)
	return en_onboarding_upload_error_parse(inputs)
});